// extracted by mini-css-extract-plugin
module.exports =  {"container":"_02712f2b3b--container--TlfVw","image":"_02712f2b3b--image--kQ5dV","description":"_02712f2b3b--description--Y970l"};